/**
 * @file FilterHeader.tsx
 * @desc Header component for custom filter
 * @copyright All rights reserved @ Inarix
 */
import React from "react";
import { Box, Typography } from "@mui/material";
import { TFunction } from "i18next";
import { customFilterFormStyles } from "../../dataTable/table/customFilterForm/CustomFilterFormStyles";

interface FilterHeaderProps {
  t: TFunction<"global", undefined>;
  comesFromDashboard?: boolean;
}

export const FilterHeader: React.FC<FilterHeaderProps> = ({
  t,
  comesFromDashboard,
}) => {
  return (
    <Box sx={customFilterFormStyles.headerRow}>
      <Box></Box>
      <Typography variant="body2" sx={customFilterFormStyles.headerText}>
        {!comesFromDashboard ? t("custom_filter.columns") : ""}
      </Typography>
      <Typography variant="body2" sx={customFilterFormStyles.headerText}>
        {t("custom_filter.operator")}
      </Typography>
      <Typography variant="body2" sx={customFilterFormStyles.headerText}>
        {t("custom_filter.value")}
      </Typography>
    </Box>
  );
};
